import { getAuctionCatalogue } from './auctionCatalogueClient';

export const getModelsWithAuctions = async (context = {}, brandId, options) => {
  if (!brandId) return [];
  return getAuctionCatalogue('getModelsWithAuctionsV2', context, {brandId}, options);
};
